import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Location } from '@angular/common';
import { IconComponent } from '@teamfoster/sdk/icon';
import { Button } from '@teamfoster/sdk/button';

@Component({
    selector: 'app-breadcrumbs',
    imports: [RouterLink, IconComponent],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent {
  breadcrumbs = input<Button[]>();
  backButton = input<boolean>();

  location = inject(Location);
  router = inject(Router);

  goBack(): void {
    const navigationId = (this.location.getState() as any)?.navigationId || 0;

    if (navigationId > 1) {
      this.location.back();
    } else {
      this.router.navigate(this.breadcrumbs()?.[0].routerLink || ['/']);
    }
  }
}
